import React from "react";

 

import NFTImage1 from "../assets/NFT/NFT-1.jpg";
import NFTImage2 from "../assets/NFT/NFT-2.jpg";
import NFTImage3 from "../assets/NFT/NFT-3.jpg";
import NFTImage4 from "../assets/NFT/NFT-4.jpg";
import NFTImage5 from "../assets/NFT/NFT-5.jpg";
import NFTImage6 from "../assets/NFT/NFT-6.jpg";
import NFTImage7 from "../assets/NFT/NFT-7.jpg";
import NFTImage8 from "../assets/NFT/NFT-8.jpg";
import NFTImage9 from "../assets/NFT/NFT-9.jpg";
import NFTImage10 from "../assets/NFT/NFT-10.jpg";
import NFTImage11 from "../assets/NFT/NFT-11.jpg";
import NFTImage12 from "../assets/NFT/NFT-12.jpg";





import BNB from "../assets/bnb.svg" 
const NFTDetails = () => {
  const data = [
  { id: 1, minted: "#10001", image: NFTImage1, name: "Cyber Warrior" },
  { id: 2, minted: "#10002", image: NFTImage2, name: "Shadow Hunter" },
  { id: 3, minted: "#10003", image: NFTImage3, name: "Galaxy Trooper" },
  { id: 4, minted: "#10004", image: NFTImage4, name: "Crypto Samurai" },
  { id: 5, minted: "#10005", image: NFTImage5, name: "Plasma Knight" },
  { id: 6, minted: "#10006", image: NFTImage6, name: "Neon Beast" },
  { id: 7, minted: "#10007", image: NFTImage7, name: "Fire Titan" },
  { id: 8, minted: "#10008", image: NFTImage8, name: "Ice Phantom" },
  { id: 9, minted: "#10009", image: NFTImage9, name: "Metal Skull" },
  { id: 10, minted: "#10010", image: NFTImage10, name: "Aqua Spirit" },
  { id: 11, minted: "#10011", image: NFTImage11, name: "Dark Ninja" },
  { id: 12, minted: "#10012", image: NFTImage12, name: "Space Guardian" },
];



  return (

    <>

      <div className="gz-wrap mb-4">


        <div className="gz-badge-row-details">
          {/* Badges */}
          <div className="gz-badge-row">
            <div className="gz-tag">COLLECTION</div>
            <div className="gz-tag">SOLANA MAINNET</div>
            <div className="gz-tag">MINTED</div>
          </div>
          {/* Top Right Stats */}
          <div className="gz-top-right">
            <div className="gz-stat-item">
              <span className="gz-icon">★</span>
              <span>3</span>
            </div>
            <div className="gz-stat-item">
              <span className="gz-icon">👁</span>
              <span>121</span>
            </div>
            <div className="gz-stat-item">2 DAYS AGO</div>
          </div>

        </div>



        <div className="GAMERZ-header">
          {/* Title */}
          <h2 className="page-title">
           <span className="text-gradeint"> GAMERZ</span>  <span className="gz-star">⭐</span>
          </h2>

          {/* Creator Section */}
          <div className="gz-creator">
            Created By <strong>95XuCG...XZLB</strong>
            <a href="#">↗</a>
          </div>

          <div className="gz-model">velogen Model</div>
        </div>

        <hr />

        {/* Stats Section */}
        <div className="gz-stats-section">
          <div className="row ">
            <div className="col-md-6">
              <div className="items-generated">     <div className="gz-label">ITEMS GENERATED</div>
                <h5>100</h5></div>
            </div>

            <div className="col-md-6">
              <div className="ITEMS-MINTED-div">
                <div className="gz-label">ITEMS MINTED</div>
                <div className="minted-progress">
                  <h5 className="gz-minted">100/100</h5>
                  <div className="progress gz-progress">
                    <div className="progress-bar gz-progress-bar"></div>
                  </div>
                </div>

              </div></div>

          </div>
        </div>

        {/* Sale Card */}
        <div className="gz-sale-card">
          <div className="gz-sale-inner">

            <div className="d-flex justify-content-between align-items-start">
              <span className="gz-on-sale">ON SALE</span>
            </div>

            <div className="div_On-sell">
              <div className="row">
                <div className="col-md-3">
                  <div className="gz-label gz-small">FLOOR PRICE</div>
                  <strong>0.2 SOL</strong>
                </div>

                <div className="col-md-3">
                  <div className="gz-label gz-small">TOTAL VOLUME</div>
                  <strong>0</strong>
                </div>

                <div className="col-md-3">
                  <div className="gz-label gz-small">OWNERS</div>
                  <strong>1</strong>
                </div>
              </div>
            </div>

          </div>
        </div>



      </div>

       <h4 className="page-title">
           <span className="text-gradeint"> MINTED NFTS </span> 
            
          </h4>


 <div className="row mt-3">
      {data.map((item) => (
        <div className="col-lg-2 col-md-6 mb-3" key={item.id}>
          <div className="card mined-NFT">
            <div className="nft-minted-pic">

              <div className="minted-counts">
                <span>MINTED</span>
                <b>{item.minted}</b>
              </div>

              <img src={item.image} alt={item.name} className="w-100" />

              <div className="nft-name">
                <h6 className="text-center mt-2">{item.name}</h6>
              </div>

            </div>
          </div>
        </div>
      ))}
    </div>
    </>



  );
};

export default NFTDetails;
